import { ShieldAccountIcon } from './ShieldAccountIcon';

/**
 * author: Michael Richins
 * id CA71D276-C056-45E5-883E-B3D15868D859
 * name shield-account
 * version: 2.1.99
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/shield-account.svg
 * tags
 * - Account / User 
 * - Home Automation 
 */
export const AlarmArmHomeIcon = ShieldAccountIcon;
export default AlarmArmHomeIcon